import api from "../utils/api";

class OperatorsPaymentMethodsApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get("/operators-payment-method/list/admin", {
          params: data,
        });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post("/operators-payment-method", data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(`/operators-payment-method/${id}`, data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.delete(`/operators-payment-method/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  copy = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post(`/operators-payment-method/copy/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateStatus = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(
          `/operators-payment-method/status/${id}`,
          data
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateUserOnApp = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(
          `/operators-payment-method/user_on_app/${id}`,
          data
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  updateOperatorOnApp = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.patch(
          `/operators-payment-method/operator_on_app/${id}`,
          data
        );
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/operators-payment-method/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const opPaymentMethodsApi = new OperatorsPaymentMethodsApi();
export default opPaymentMethodsApi;
